"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEATURE_FLAG_API_AFFIRM = exports.FEATURE_FLAG_API_BASE_URL = exports.HABITAT_ASSESSMENTS_API_BASE_URL = exports.STANDARDS_API_V2_BASE_URL = exports.STANDARDS_API_BASE_URL = exports.DIGITAL_KEY_TOKEN = exports.APPLICATION_TOKEN = exports.ASSIGNMENTS_API_BASE_URL = exports.AUTH_API_BASE_URL = exports.ROSTERING_API_BASE_URL = exports.ASSESSMENTS_API_BASE_URL = void 0;
exports.ASSESSMENTS_API_BASE_URL = '/insync/assessments/api';
exports.ROSTERING_API_BASE_URL = '/';
exports.AUTH_API_BASE_URL = '/';
exports.ASSIGNMENTS_API_BASE_URL = '/assignments/api';
exports.APPLICATION_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwbGF0Zm9ybSI6eyJpZCI6ImluLXN5bmMifX0.ipd-Hz3-ra3cMJfN3DCeUZTtKAp5pRhuTDdzObBfDbs';
exports.DIGITAL_KEY_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwbGF0Zm9ybSI6eyJpZCI6ImRpZ2l0YWwifX0.qjL312eo8te1ZTx0ADkpryf0QQU_k8kdcBpjI2vsc6c';
exports.STANDARDS_API_BASE_URL = '/standards/api';
exports.STANDARDS_API_V2_BASE_URL = '/standards';
exports.HABITAT_ASSESSMENTS_API_BASE_URL = '/assessments/api';
exports.FEATURE_FLAG_API_BASE_URL = '/feature-flags/api';
exports.FEATURE_FLAG_API_AFFIRM = "".concat(exports.FEATURE_FLAG_API_BASE_URL, "/feature-flags/affirm_fe");
